/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from "react"
import TopHeader from "../../components/TopHeader"
import { useSelector,useDispatch } from "react-redux"
import { useEffect,useCallback,useContext ,useState} from "react"
import { useLocation,useSearchParams } from "react-router-dom"
import Debounce from "../../CommonMethods/Debounce"
import { limitReducer, resetArrays } from "../../redux/MultiselectRows"
import Pagination from "../../components/Pagination"
import Limit from "../../components/Limit"
import GlobalContext from "../../components/Context/GloablContext"
import CustomOverLay from "../../components/CustomOverLay"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import Emptyscreen from "../../components/EmptyScreen"
import moment from "moment"
import { convertDatesToEpochUTC } from "../../CommonMethods/ConvertFilterDatetoEpochUtcFormat"
import { useExportActivityLogListMutation, useGetAccessLogsListQuery } from "../../features/activityHistorySlice"
import TopBarAccessLog from "./Components/Topbar"
import AccessLogTable from "./Components/Table"
import Emptyscreenwithouttitle from "../../components/Emptyscreenwithouttitle"
import AccessLogSearch from "./Components/AdvancedSearch"
import { resetAccessLogSearch, setAccessLogSearchApplied } from "../../redux/accessLogSearchSlice"

export default function ManageAccessLogs(){
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,isAdvancedSearchOpen} = useContext(GlobalContext);
    const [exportAccessLog]=useExportActivityLogListMutation()
    const [suggestions,setSuggestions]=useState("")
    const [limit,setLimit]=useState("15")
    const [skip,setSkip]=useState(true)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [isSortselected,setisSortSelected]=useState(false)
    const [datePartialFilled,setDatePartialFilled]=useState(false)
    const accessLogSearch = useSelector(state => state.accessLogSearchData);
    const searchApplied = useSelector((state) => state.accessLogSearchData.accessLogSearchApplied);


    
    const auth=useSelector(state=>state?.auth)

    const [selectedOrganizationName, setSelectedOrganizationName] = useState([{
        organization_name: '',
        organization_id: '',
    }]);
    const [subDivisionDataLoading,setSubDivisionDataLoading]= useState(false)
    const userArr=useSelector(state=>state?.subdivSelect?.subdivData?.checkedArr)

    const initialState={
        "user_name":'',
        "action":'',
    }
    const [filterValues,setFilterValues]=useState(initialState)

    const initialDateState = {
        "start_date":searchParams?.get('start_date')?`${new Date(parseInt(searchParams?.get('start_date'))*1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('start_date'))*1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('start_date'))*1000).getDate()).padStart(2, '0')}`:new Date(),
        "end_date":searchParams?.get('end_date')?`${new Date(parseInt(searchParams?.get('start_date'))*1000).getFullYear()}-${String(new Date(parseInt(searchParams?.get('end_date'))*1000).getMonth() + 1).padStart(2, '0')}-${String(new Date(parseInt(searchParams?.get('end_date'))*1000).getDate()).padStart(2, '0')}`:new Date(),
        
    }
    const [filterDateValues,setFilterDateValues]=useState(initialDateState)
    const {data,isFetching,isLoading,status}=useGetAccessLogsListQuery(searchParams?.toString(),{skip: skip||location.search===''})
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);

        params.page_number = 1
        params.last_page = null
        params.last_id = null

        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    

    useEffect(() => {
        if(location.search===''){
            setSkip(true)
        }
        if(location.state!==null&&location.state!==''&& !Array.isArray(location.state)){
            let params={};
            if(location?.state?.search!==''){
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'created_at+desc',
                    'search':decodeURIComponent(location.state.search)
                }
            }else{
                params={
                    'limit':location.state.limit,
                    'page_number':location.state.page_number,
                    'sort':'created_at+desc',
                }

            }
            setSearchParams({...params})
            
        }
        else{
            if(!searchParams.get('limit')){
                handleSearchParams('limit','15')
           
            }
            if(!searchParams.get('page_number')) { 
                handleSearchParams('page_number', '1')
            }
            if(!searchParams.get('start_date')) { 
                handleSearchParams('start_date', convertDatesToEpochUTC(moment(filterDateValues?.start_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,true))
            }
            if(!searchParams.get('end_date')) { 
                handleSearchParams('end_date', convertDatesToEpochUTC(moment(filterDateValues?.end_date).format('YYYY-MM-DD'),Intl.DateTimeFormat().resolvedOptions().timeZone,false))
            }
            if(!searchParams.get('filter')) {
                handleSearchParams('filter', `true`)
            }

        }
        
        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')
        
    }, [location]);

    useEffect(()=>{
        if(searchParams.size>=7){
            setSkip(false)
        }
        else{
            setSkip(true)
        }
    },[searchParams])

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params.last_page = null
        params.last_id = null
        if (type) {
            if (filterValues?.user_name?.trim() !== '') {
                params.user_name = filterValues?.user_name?.trim();
            } else {
                delete params.user_name;
            }
            if (filterValues?.action !== '') {
                params.result = filterValues?.action;
            } else {
                delete params.result;
            }

            setSearchParams({ ...params });
    
        } else {
            // Clear filterValues when type is false
    
            setFilterValues(  {
                "user_name":'',
                "action":'',
            });
    
            delete params.user_name;
            delete params.result;
   
            setSearchParams({ ...params });
        }
    };
    
   
    function handleNoOfRowsClick(number) {
        let params = Object.fromEntries(searchParams);  
        params.page_number = 1;
        params.last_page= null
        params["limit"] = number;
        params['last_id']=null
        params['last_page'] =null
        setSearchParams({ ...params });

    }
    const handleOnClickPageNumber = (pageNum) => {
        setisSortSelected(false)
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum,last_id:(pageNum===1?null:searchParams?.get('page_number')>pageNum?(data?.data?.[0]?._id!==undefined?data?.data[0]?._id:null):(data?.data?.[data?.data?.length-1]?._id!==undefined?data?.data[data?.data?.length-1]?._id:null)),last_page:(pageNum===1?null:searchParams?.get('page_number')>pageNum?searchParams?.get('page_number'):searchParams?.get('page_number')) })       
    }

    useEffect(() => {
        if(data!==undefined){
            dispatch(limitReducer([data,searchParams.get("limit"),searchParams.get("page_number")]))
        }
    }, [data?.data]);

    const handleChange = (val) => {
        handleSearchParams('search', val)
        
    };

    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );


    const handleDispatch = useCallback(() => {
        if (!searchParams.get('limit')) {
            handleSearchParams('limit', '15');
        }
        if (!searchParams.get('page_number')) {
            handleSearchParams('page_number', '1');
        }
        if (!searchParams.get('last_id')) {
            data===undefined?handleSearchParams('last_id', null):handleSearchParams('last_id', data?.data?.[data?.data?.length-1]?._id);
        }
        if (!searchParams.get('last_page')) {
            handleSearchParams('last_page', null)
        }
        
        
    }, [location]);

    useEffect(() => {
        handleDispatch()
        
    }, [handleDispatch]);

    // apply search function
    const handleOnSubmit = (e) => {            
        e.preventDefault();
        
        let searchString = '';
            
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };
    
        // Check for `user_id` and `user_id_inverse` conditions
        if (accessLogSearch?.user_id && accessLogSearch.user_id.trim() !== '') {
            const patientIdPrefix = accessLogSearch.user_id_inverse ? 'ne:' : '';
            const formattedPatientId = formatSearchValue(accessLogSearch.user_id);
            searchString += `user_id=${patientIdPrefix}${encodeURIComponent(formattedPatientId)};`;
        }
    
        // Check for `timezone` and `timezone_inverse` conditions
        if (accessLogSearch?.timezone && accessLogSearch.timezone.trim() !== '') {
            const timezonePrefix = accessLogSearch.timezone_inverse ? 'ne:' : '';
            const formattedtimezone = formatSearchValue(accessLogSearch.timezone);
            searchString += `timezone=${timezonePrefix}${encodeURIComponent(formattedtimezone)};`;
        }
    
        // Check for `action` and `action_inverse` conditions
        if (accessLogSearch?.action && accessLogSearch.action.trim() !== '') {
            const actionPrefix = accessLogSearch.action_inverse ? 'ne:' : '';
            const formattedAction = formatSearchValue(accessLogSearch.action);
            searchString += `action=${actionPrefix}${encodeURIComponent(formattedAction)};`;
        }
    
        // check for ip_address field 
        if (accessLogSearch?.ip_address && accessLogSearch.ip_address.trim() !== '') {
            const valuePrefix = accessLogSearch.ip_address_inverse ? 'ne:' : '';
            const formattedValue = formatSearchValue(accessLogSearch.ip_address);
            searchString += `ip_address=${valuePrefix}${encodeURIComponent(formattedValue)};`;
        }
    
        // check for device_information field
        if (accessLogSearch?.device_information) {
            const orgIDPrefix = accessLogSearch.device_information_inverse ? 'ne:' : '';
            const formattedOrgId = formatSearchValue(accessLogSearch.device_information);
            searchString += `device_information=${orgIDPrefix}${encodeURIComponent(formattedOrgId)};`;
        }
    
        // check for value field 
        if (accessLogSearch?.value && accessLogSearch.value.trim() !== '') {
            const valuePrefix = accessLogSearch.value_inverse ? 'ne:' : '';
            const formattedUserID = formatSearchValue(accessLogSearch.value);
            searchString += `value=${valuePrefix}${encodeURIComponent(formattedUserID)};`;
        }

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
            
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: accessLogSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            last_id: null, // Reset last_id on new search
            last_page: null, // Reset last_page on new null
            limit: currentParams.limit || '15', // Keep limit or set default
        };
        
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
        
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        setisSortSelected(false)
        dispatch(setAccessLogSearchApplied());
            
    };
        
    
    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {            
            dispatch(resetAccessLogSearch());
        }
    }, [dispatch, searchApplied]);


    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Access Logs"}/>
                <div className='bg-white rounded-lg pt-3 h-customh3 relative'>
                    <div className="px-6">
                        <TopBarAccessLog
                            title={'List of Access Logs'}
                            AddButton={true}
                            SearchInput={((data?.data?.length===0 &&searchParams.get("search")===null) ||data===undefined) ? false : true}
                            ApplyFilter={true}
                            suggestions={suggestions}
                            setSuggestions={setSuggestions}
                            optimizedFn={optimizedFn}
                            data={data}
                            exportCols={['ID','Username','Timestamp','Timezone','Action','IP Address','Device','Result','Value']}
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportAccessLog={exportAccessLog}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            filterDateValues={filterDateValues}
                            setFilterDateValues={setFilterDateValues}
                            handleApplyFilter={handleApplyFilter}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            userArr={userArr}
                            subDivisionDataLoading={subDivisionDataLoading}
                            TotalCount={parseInt(data?.total_count)}

                        />
                    </div>
                    {((isFetching&&status!=="fulfilled"&&status!=="rejected"&&!isSortselected)||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Access Logs list..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay':'overlay-list'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>
                        <div className="px-6">
                            <AccessLogTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={data}
                                handleSearchParams={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setisSortSelected={setisSortSelected}
                            />
                        </div>
                        {data?.total_count>=15 &&<div className="w-[100%] px-2.5 py-1 flex items-center justify-between bg-[#F4F7FC] rounded-b-[8px]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                            <div className="flex items-center">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(data?.total_count===0 &&suggestions?.trim()!=="")||(data?.success_status==="false")||(searchParams.get('user_name')!==null||searchParams.get('result')!==null) ?
                            <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria"} />
                            :
                            data?.total_count===0&&!searchParams.get("search")?<Emptyscreenwithouttitle
                                FirstPTag={"No access log yet"}
                            />:((status==="rejected"||(data?.total_count!==0&&data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}
                </div>
            </div>
            {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams?.get('target_user_name') &&
                <AccessLogSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled}
                />
            }
        </>
   
    )
}


